import { useEffect } from "react";

// Labels every <td> with its column header so CSS can render tables as cards on small screens.
export function useMobileTableLabels(dep) {
  useEffect(() => {
    const label = () => document.querySelectorAll("table").forEach((t) => {
      const heads = [...t.querySelectorAll("thead th")].map((th) => th.textContent.trim());
      if (!heads.length) return;
      t.classList.add("mobile-cards");
      t.querySelectorAll("tbody tr").forEach((tr) => [...tr.children].forEach((td, i) => { if (heads[i]) td.setAttribute("data-label", heads[i]); }));
    });
    label();
    const obs = new MutationObserver(() => label());
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, [dep]);
}
